<div
    [ngClass]="{ 'is-visible': _isVisible }"
    class="container-areas"
    id="container-areas"
>
    <ng-container *ngIf="_isVisible" [ngSwitch]="activeViewMode">
        <app-areas-list
            #areaList
            *ngSwitchCase="AreaPanelViewMode.List"
            (addArea$)="onClickAddArea($event)"
            (close$)="close$.emit()"
        ></app-areas-list>
        <app-area-form 
            *ngSwitchCase="AreaPanelViewMode.Form"
            (back$)="onClickBackInForm($event)"
            (onSelectAreaType$)="onSelectAreaType($event)"
            [area]="editArea"
            [isEditMode]="!!editArea"
        ></app-area-form>
    </ng-container>
</div>

<div *ngIf="(_isVisible && activeViewMode === AreaPanelViewMode.Form && selectedAreaTypeInForm) || editArea?.Id" class="container-areas__hint">
    <i class="pi pi-info-circle container-areas__hint__icon"></i>
    <span class="container-areas__hint__title">
        {{'areas.hintHowToDrawArea' | translate}}
    </span>
</div>
